import React from 'react';
import close from '../../img/icon-close.svg';

import './Popup.scss';

const Popup = ({ onClose, children, img }) => {
    return (
        <div className="overlay-fixed active">
            <div className="popup-wrapper">
                <button className="popup-close" onClick={onClose}>
                    <img src={close} alt="Close" />
                </button>
                <div
                    className="item-wrapper"
                    style={img ? { backgroundImage: `url(${img})`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat:'no-repeat' } : {}} >

                    {children}

                </div>
            </div>
        </div>
    );
};

export default Popup;
